<script setup lang="ts">
import { computed } from 'vue';
import * as marked from 'marked';

interface MarkdownWrapperProps {
  source: string | null;
}

const props = defineProps<MarkdownWrapperProps>();

// NOTE: Markdown comes from inside the system. Should be fine without sanitization
const formattedMarkdown = computed(() =>
  props.source ? marked.parse(props.source).replace('<hr>', '') : ''
);
</script>

<template>
  <div v-html="formattedMarkdown" />
</template>
